import {Box, Stack, Typography} from '@mui/material';
import {ArrowBack, ArrowForward} from '@mui/icons-material';
import React from 'react';
import {ExtendedILink} from './type';
import {t} from 'i18next';

interface ILinkToolTip {
  item: ExtendedILink | null;
}
const LinkTooltip = ({item}: ILinkToolTip) => {
  return (
    <Box className="bubble-tooltip-container">
      <Typography
        className="typo-text label3_size"
        data-testid={`link-tooltip-tooltip-title`}
      >
        {t('reports.communicationExplorer.tooltip.tooltipTitle')}
      </Typography>
      <Box className="mail-block">
        <Typography
          className="typo-text label3_size"
          data-testid={`link-tooltip-source-name--${item?.index ?? ''}`}
        >
          {item?.source.name}
        </Typography>
        <ArrowBack className="focus-arrow" />
        <ArrowForward className="focus-arrow" />
        <Typography
          className="typo-text label3_size"
          data-testid={`link-tooltip-typography-target--${item?.index ?? ''}`}
        >
          {item?.target.name}
        </Typography>
      </Box>
      <Box className="mail-block">
        <Stack className="mail-section">
          <Typography
            className="typo-text label3_size"
            data-testid={`link-tooltip-sent-by-${item?.index ?? ''}`}
          >
            {t('reports.communicationExplorer.tooltip.sentBy', {
              sender: item?.source.name,
            })}
          </Typography>
          <Typography
            className="typo-text label3_size"
            data-testid={`link-tooltip-sent-by-count-${item?.index ?? ''}`}
          >
            2
          </Typography>
        </Stack>
        <Stack className="mail-section">
          <ArrowBack className="focus-arrow" />
          <ArrowForward className="data-arrow" />
        </Stack>
        <Stack className="mail-section">
          <Typography
            className="typo-text label3_size focus-text"
            data-testid={`link-tooltip-total`}
          >
            {t('reports.communicationExplorer.tooltip.total')}
          </Typography>
          <Typography
            className="typo-text label3_size"
            data-testid={`link-tooltip-total-count-${item?.index ?? ''}`}
          >
            5
          </Typography>
        </Stack>
        <Stack className="mail-section">
          <ArrowForward className="focus-arrow" />
          <ArrowBack className="data-arrow" />
        </Stack>
        <Stack className="mail-section">
          <Typography
            className="typo-text label3_size"
            data-testid={`link-tooltip-sent-to-${item?.index ?? ''}`}
          >
            {t('reports.communicationExplorer.tooltip.sentTo', {
              receiver: item?.target.name,
            })}
          </Typography>
          <Typography
            className="typo-text label3_size"
            data-testid={`link-tooltip-sent-to-count-text-${item?.index ?? ''}`}
          >
            5
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default LinkTooltip;
